export const expiredSearchFolder_tooltip = "PHDRNb";
export const expiredSearchFolder_dialogTitle = "UTU5he";
export const expiredSearchFolder_dialogBody = "QM1Ofe";
export const expiredSearchFolder_reactivateButton = "INHmOe";
export const expiredSearchFolder_deleteButton = "hNE1j";
export const crossAccountMoveBlockedTooltip = "X2Iajb";
export default {expiredSearchFolder_tooltip,expiredSearchFolder_dialogTitle,expiredSearchFolder_dialogBody,expiredSearchFolder_reactivateButton,expiredSearchFolder_deleteButton,crossAccountMoveBlockedTooltip};